
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"none","d":"M0 0h24v24H0z"}}),_c('g',{attrs:{"fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M19.524 4.545H2v1.913h1.679l.654 12.844C4.547 21.41 6.211 23.006 8.19 23h7.62c1.975 0 3.632-1.595 3.845-3.698l.666-12.844H22V4.545h-2.476zm-1.631 14.528c-.116 1.136-1.016 1.995-2.083 1.989H8.19c-1.063 0-1.956-.857-2.071-1.99L5.464 6.459h13.072l-.643 12.615z","fill":"#000"}}),_c('path',{attrs:{"fill":"#000","d":"M6 1h2v4H6zM16 1h2v4h-2zM8 1h8v2H8z"}}),_c('path',{attrs:{"d":"M9 9.08L10.174 9l.326 8.92-1.174.08L9 9.08zm5 8.839L14.327 9l1.173.081L15.173 18 14 17.919z","fill":"#03B328"}})])])])
          )
        }
      }
    